import { render, staticRenderFns } from "./FullScreenMobile.vue?vue&type=template&id=38c2d9b7"
import script from "./FullScreenMobile.vue?vue&type=script&lang=js"
export * from "./FullScreenMobile.vue?vue&type=script&lang=js"
import style0 from "./FullScreenMobile.vue?vue&type=style&index=0&id=38c2d9b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports